<template>
  <div>
    <div class="data_con" v-if="!isMobile">
      <div class="data_item" v-for="(d, index) in data" :key="index">
        <div
          class="data_one"
          v-for="(f, index) in d.details.fileUrl"
          :key="index"
          @click="handelTemplate(f)"
        >
          <img src="../../../assets/img/down_icon.png" />
          <p>{{ d.title }}</p>
        </div>
        <!-- <div class="data_one" @click="handelTemplate(d.details.fileUrl)">
          <img src="../../../assets/img/down_icon.png" />
          <p>{{ d.title }}</p>
        </div> -->
      </div>
    </div>
    <div class="app_data_con" v-else>
      <div class="data_item" v-for="(d, index) in data" :key="index">
        <div class="data_one">
          <p>{{ d.title }}</p>
          <img src="../../../assets/img/down_icon.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import responsiveMixin from '@/mixins/responsiveMixin';
import { fetchConentList } from '@/assets/api';
export default {
  name: 'Question',
  mixins: [responsiveMixin],
  props: {
    cloumnId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: [
        {
          title: '今年的青年竞演报名提交方式是否有变化？',
        },
        {
          title: '是否需要提供剧本？',
        },
        {
          title: '2024年青年竞演报名截止时间跟往年一样吗？',
        },
      ],
    };
  },
  mounted() {
    console.log('this.cloumnId', this.cloumnId);
    this.getList();
  },
  methods: {
    getList() {
      const data = {
        columnIds: this.cloumnId,
        size: 999,
        current: 1,
      };
      fetchConentList(data).then((res) => {
        this.data = res.records;
        this.data = this.data.map((d) => {
          d.details.fileUrl =
            d.details && d.details.fileUrl ? d.details.fileUrl.split(',') : [];
          return d;
        });
      });
    },
    handelTemplate(url) {
      const link = document.createElement('a');
      link.href = url;
      // link.download = 'template.doc'; // 明确设置文件名
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // 兼容性处理：如果不起作用，尝试用 window.open
      setTimeout(() => {
        if (!link.visited) {
          window.open(url, '_blank');
        }
      }, 500);
    },
    /** 下载模板 */
    // handelTemplate(url) {
    //   const link = document.createElement('a');
    //   link.href = url; // 替换为你的文件路径
    //   // link.download = '模板.xlsx'; // 设置下载文件的名称
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // },
  },
};
</script>
<style lang="scss" scoped>
.data_con {
  .data_item {
    width: 60%;
    margin: 0 auto;

    .data_one {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin: 2.5rem;
      cursor: pointer;

      p {
        border-bottom: solid 1px #6b6d7a;
      }
    }
  }
}
.app_data_con {
  .data_item {
    width: 100%;
    margin: 0 auto;

    .data_one {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 1.6667rem 0;
      img {
        width: 1.3333rem;
        height: 1.3333rem;
      }
    }
  }
}
</style>
